import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=2c748311&scoped=true&"
import script from "./Doctor.vue?vue&type=script&lang=js&"
export * from "./Doctor.vue?vue&type=script&lang=js&"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=2c748311&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c748311",
  null
  
)

export default component.exports